// extracted by mini-css-extract-plugin
export default {"heroItem":"_5d419b8a","isVisible":"_ba42c41b","imageWrapper":"_bdc5f95b","image":"_c5d4efa8","title":"_17fe65ef"};